import { combineReducers } from "redux";
import { utilityErrorsReducer } from "./utilities";

export default combineReducers({
    utilities: utilityErrorsReducer
})